import React, { Component } from 'react';
import { APP_CONST } from '../../constants';
import { GeckoCard, GeckoAlert, } from '../../components';
import { $state } from '../../router';
import { Auth, TokenManager } from '../../services';

// Account Modules
import ModuleBasic from './components/ModuleBasic';
import ModulePassword from './components/ModulePassword';
import ModuleTwoFactor from './components/ModuleTwoFactor';
import ModuleActivity from './components/ModuleActivity';
import ModuleActiveSessions from './components/ModuleActiveSessions';

// Styles
import './styles.css';

export class AccountPage extends Component {
    state = {
    }

    constructor(props) {
        super(props);

        this.setAlert = this.setAlert.bind(this);
        this.iam = this.iam.bind(this);
    }

    modules = [{
        key: 'Basic',
        title: 'User Account Details',
        component: ModuleBasic,
    }, {
        key: 'Password',
        title: 'Change Password',
        component: ModulePassword,
        hideWhen: () => {
            return this.isSSOUser();
        },
    }, {
        key: 'TwoFactor',
        title: 'Two Factor Authentication',
        component: ModuleTwoFactor,
        hideWhen: () => {
            return this.isSSOUser();
        },
    }, {
         key: 'ActiveSessions',
         title: 'Active Sessions',
         component: ModuleActiveSessions,
     }, {
        key: 'Activity',
        title: 'Activity',
        component: ModuleActivity,
    },];

    isSSOUser() {
        // SSO users cant change their password.
        const tm = TokenManager.fromLocalStorage();
        const IdJwt = tm.IdToken;
        const IdToken = TokenManager.decode(IdJwt);

        if (IdToken.identities) {
            return true;
        }

        return false;
    }

    /* ====================

        Lifcycle

    ==================== */

    componentDidMount() {
        this.iam();
    }


    /* ====================

        Global Methods

    ==================== */
    logout() {
        return $state.go('logout');
    }

    iam() {
        return Auth.iam().then((data) => {
            this.setState({
                user: data,
            })
        })
        .catch((err) => {
            this.setState({ alert: err.Error });
        })
    }

    setAlert(alert) {
        this.setState({
            alert: alert,
        })
    }

    /* ====================

        Renders

    ==================== */

    renderModules() {
        return this.modules.map((module, key) => {
            if (module.hideWhen && module.hideWhen() === true) {
                return null;
            }

            if (module.render) {
                return module.render();
            }

            return this.renderModule(module);
        })
    }


    renderModule(module) {
        const ModuleComponent = module.component;

        return (
            <div key={module.key} id={'module-' + module.key} className="moduleContainer">
                <div className="row">
                    <div className="col">
                        <div className="moduleTitle">
                            {module.title}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <GeckoCard padded={true}>
                            <ModuleComponent module={module} data={{user: this.state.user}} setAlert={this.setAlert} iam={this.iam} />
                        </GeckoCard>
                    </div>
                </div>
            </div>
        )
    }

    renderAlert(message = null) {
        if (message) {
            return (
                <GeckoAlert className="z-depth-3 stickyAlert" type={APP_CONST.ALERT_TYPE_SUCCESS}>
                    {message}
                </GeckoAlert>
            )
        }

        return null;
    }

    render() {

        return (
            <div>
                {this.renderAlert(this.state.alert)}
                {this.renderModules()}
            </div>
        );
    }
}

export default AccountPage;
